import React, {Component} from "react"
import JsxMarker from "./JsxMarker";
import { colorForCompany } from "./colors";

class TruckMarker extends Component {
    constructor() {
        super();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.markerKey != nextProps.markerKey;
    }

    render() {
        const color = colorForCompany(this.props.companyId);

        // Regel 1 = klantnaam. Regel 2 = karnummer (#nr) zodra de API dat
        // meegeeft; tot dan valt het terug op de karnaam (title) als die er is.
        const hasNr = this.props.nr !== undefined && this.props.nr !== null && this.props.nr !== "";
        const second = hasNr ? ("#" + this.props.nr) : (this.props.title || null);

        return (
            <JsxMarker className="cartDivIcon" position={{lat: this.props.lat, lng: this.props.lng}}>
                <div className="cartMarker" style={{color: color}}>
                    <span className="cartDot" />
                    <span className="cartLabel">
                        {this.props.clientName ? <span className="cartClient">{this.props.clientName}</span> : null}
                        {second ? <span className="cartNr">{second}</span> : null}
                    </span>
                </div>
            </JsxMarker>
        )
    }
}

export default TruckMarker
